<template>
  <div
    class="flex"
    :class="`
      ${align ? 'align-' + align : ''}
      ${justify ? 'justify-' + justify : ''}
    `"
    :style="{marginBottom: mb, marginTop: mt}"
  >
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'flex',
    props: {
      align: String,
      justify: String,
      mb: String,
      mt: String
    }
  }
</script>

<style scoped>
  .flex {
    display: flex;
  }
  .align-center {
    align-items: center;
  }
  .align-bottom {
    align-items: flex-end;
  }
  .align-top {
    align-items: flex-start;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-around {
    justify-content: space-around;
  }
  .justify-between {
    justify-content: space-between;
  }
</style>
